import { useState, useNavigate, toast, FaEyeSlash, useEffect } from '../../../common/common';
import Navigations from '../../../common/useNavigation.js';
import { useErrorContext } from '../../../context/ErrorContext.js';
import axiosJWT from '../../../secureAPI/axiosJWT.js';
import getUserData from '../../../secureAPI/GetUserData.jsx';
import { StopLoading, StartLoading } from '../../../Utils/loadingUtils.js';
import { showToast } from '../../../Utils/toastUtils.js';
import useGetUserData from '../../../secureAPI/GetUserData';

const MidProductAttributes = () => {
    const navigate = useNavigate();

    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const [getattributes, setAttributes] = useState([]);
    const [values, setValues] = useState([]);
    const { navigateMain, navigateSellerReorderProductAttributes, navigateDashboard,navigateSellerProductAttributes , navigateBuyerBusinessdetails } = Navigations();
    const [checkedIds, setCheckedIds] = useState([]);
    const { users } = useGetUserData();
    const [uservalues, setUserValue] = useState({
        isIndian: "",
        isPersonalDetails: "",
        primaryContact: "",
        emailnmobi: "",
        contactnumber: "",
        companyName: "",
        companyInitials: "",
        companyWebsite: "",
        companyGST: "",
        address1: "",
        address2: "",
        country: 101,
        state: 73,
        city: 12545,
        zipCode: "",
    });
    useEffect(() => {
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);
    const logUserData = () => {
        if (users?.length > 0) {

            if(users[0]["IsPersonalDetils"] === 0 ){
               navigateBuyerBusinessdetails('seller');
            }
            else if (users[0]['IsUserAttributes'] === 1  && (users[0]['UserType'].includes('1') && users[0]['UserType'].includes('2')))
            {
                navigateDashboard('seller');
            }
            else if (users[0]['IsUserAttributes'] === 0 && users[0]['UserType'].includes('2')) {
            // else if (users[0]['IsUserAttributes'] === 0 && users[0]['UserType'].includes('1')) {
                navigateSellerProductAttributes();
            }
            else {
                setUserValue({
                    ...values,
                    emailnmobi: users[0]['EmailAddress'],
                    primaryContact: users[0]['Mobile'],
                    isIndian: users[0]['IsIndian'],
                    isPersonalDetails: users[0]['IsPersonalDetils'],
                });

            }
        }
    };

    useEffect(() => {
        try {
            StartLoading(setisLoading, setisDisabled);
            setTimeout(async () => {
                try {
                    await getProductAttributes();  // Assuming this is defined elsewhere
                } catch (error) {
                    console.error('Failed to fetch product attributes', error);
                }
            }, 1000);

        } catch (error) {
            console.error('Error checking authentication status', error);
            // navigate('/', { replace: true });
        }
    }, [navigate]);

    const getProductAttributes = async () => {
        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProductAttributes`, {}, { withCredentials: true})
                .then(handleProductAttributesResponse)
                .catch(handleProductAttributesError);
        } catch (err) {
            console.error('Error fetching product attributes:', err);
        }
    };
    const handleProductAttributesResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulProductAttributes(result);
        } else {
            showToast(result.message, 'error');
        }

        StopLoading(setisLoading, setisDisabled);
    };
    const handleSuccessfulProductAttributes = (result) => {
        const { message, data } = result;
        // setUserid(1);
        setAttributes(data);
        // showToast(message, 'success');

    };
    const handleProductAttributesError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        StopLoading(setisLoading, setisDisabled);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sortedValues = [...checkedIds].sort((a, b) => a - b);
        const reducedString = sortedValues.reduce((acc, curr) => `${acc}${curr},`, '');
        const resultString = reducedString.replace(/,*$/, '');
        insertuserattribute(resultString);
    };
    const insertuserattribute = async (resultString) => {

        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/SetProductAttributes`, { resultString, app: 0 }, { withCredentials: true, credentials: 'include' })
                .then(handleSetProductAttributesResponse)
                .catch(handleSetProductAttributesError);
        }
        catch (err) {
            console.error('Error submit product attributes:', err);
        }
    };

    const handleSetProductAttributesResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulSetProductAttributes(result);
        } else {
            showToast(result.message, 'error');
        }

        StopLoading(setisLoading, setisDisabled);
    };

    const handleSuccessfulSetProductAttributes = (result) => {
        const { message } = result;
        showToast(message, 'success');
        navigateSellerReorderProductAttributes();

    };
    const handleSetProductAttributesError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        StopLoading(setisLoading, setisDisabled);
    };

    return { users,getattributes, isLoading, isDisabled, handleSubmit, checkedIds, setCheckedIds }
}

export default MidProductAttributes